module.exports = false;



//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/core-js/modules/_library.js
// module id = 63
// module chunks = 1